import {
  EhsFormioDateTimePicker,
  FormioDateTimePickerType,
  EhsFormioTimeInput,
  FormioTimeInputType,
  EhsFormioInfoModal,
  EhsFormioInfoModalType,
  EhsFormioComponents,
  EhsFormioSVSSelect,
  EhsFormioSVSSelectType
} from './ehs';

EhsFormioComponents.addComponent(
  FormioDateTimePickerType,
  EhsFormioDateTimePicker
);
EhsFormioComponents.addComponent(FormioTimeInputType, EhsFormioTimeInput);
EhsFormioComponents.addComponent(EhsFormioInfoModalType, EhsFormioInfoModal);
EhsFormioComponents.addComponent(EhsFormioSVSSelectType, EhsFormioSVSSelect);
export * from './ehs/';
export * from './FormioContainer';
export * from './FormioBuilder';
